document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('.home-non-invasive .box-left ul li');

    menuItems.forEach(item => {
        const subMenu = item.querySelector('.sub-menu');

        if (subMenu) {
            item.addEventListener('mouseenter', function() {
                subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
                subMenu.style.opacity = '1';
            });

            item.addEventListener('mouseleave', function() {
                subMenu.style.maxHeight = '0';
                subMenu.style.opacity = '0';
            });
        }
    });
});